import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../ReducerRegister";
import RoomMemberService from "../../../services/screens/chinesepark/RoomMemberService";
import RoomSettingService from "../../../services/screens/chinesepark/RoomSettingService";
import { ActionTypes } from "../../actionTypes/screens/chinesepark/RoomMemberActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.chinesepark.roommember;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (searchVO) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, searchVO});

            RoomMemberService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    deleteMemberUsersAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_MEMBER_USERS_ASYNC });

            RoomMemberService.deleteMemberUsers(
                vo,
                response => {
                    dispatch(Actions.deleteMemberUsersSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.deleteMemberUsersFailure(error));
                }
            );
        };
    },

    deleteMemberUsersSuccess: (data, vo) => ({
        type: ActionTypes.DELETE_MEMBER_USERS_SUCCESS,
        parentType: ActionTypes.DELETE_MEMBER_USERS_ASYNC,
        data,
        vo
    }),

    deleteMemberUsersFailure: error => ({
        type: ActionTypes.DELETE_MEMBER_USERS_FAILURE,
        parentType: ActionTypes.DELETE_MEMBER_USERS_ASYNC,
        error
    }),

    setSelectedIds: selectedIds => ({
        type: ActionTypes.SET_SELECTED_IDS,
        selectedIds
    }),

    sendNotificationAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEND_NOTIFICATION_ASYNC });

            RoomSettingService.sendEmail(
                vo,
                response => {
                    dispatch(Actions.sendNotificationSuccess(response));
                },
                error => {
                    dispatch(Actions.sendNotificationFailure(error));
                }
            );
        };
    },

    sendNotificationSuccess: data => ({
        type: ActionTypes.SEND_NOTIFICATION_SUCCESS,
        parentType: ActionTypes.SEND_NOTIFICATION_ASYNC,
        postReducer: sendNotificationSuccessPostReducer,
        data
    }),

    sendNotificationFailure: error => ({
        type: ActionTypes.SEND_NOTIFICATION_FAILURE,
        parentType: ActionTypes.SEND_NOTIFICATION_ASYNC,
        error
    }),

    activateAccountAsync: (classId, selectedIds, roomId) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.ACTIVATE_ACCOUNT_ASYNC, classId, selectedIds, roomId });

            RoomMemberService.activateMemberAccount(
                classId,
                selectedIds,
                roomId,
                response => {
                    dispatch(Actions.activateAccountSuccess(response));
                },
                error => {
                    dispatch(Actions.activateAccountFailure(error));
                }
            );
        };
    },

    activateAccountSuccess: (data) => ({
        type: ActionTypes.ACTIVATE_ACCOUNT_SUCCESS,
        parentType: ActionTypes.ACTIVATE_ACCOUNT_ASYNC,
        data
    }),

    activateAccountFailure: error => ({
        type: ActionTypes.ACTIVATE_ACCOUNT_FAILURE,
        parentType: ActionTypes.ACTIVATE_ACCOUNT_ASYNC,
        error
    }),

    showStudentLink: val => ({
        type: ActionTypes.SHOW_STUDENT_LINK,
        val,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    classDetails: null,
    memberList: [],
    shiftableClasses: [],
    pageCount: 0,
    totalCount: 0,
    searchVO:{
        classId: "",
        roomId: "",
        pageSize: 20,
        pageIndex: 1,
    },
    selectedIds: new Set(),
    showStudentLink: false,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    let newSearchVO = _.clone(searchVO);
    newSearchVO.classId = data.classId;
    newSearchVO.roomId = data.roomId;
    return { ...state, classDetails: data.classDetails, memberList: data.roomMembers, shiftableClasses: data.shiftableClasses, searchVO: newSearchVO, pageCount:data.pageCount, totalCount: data.totalCount};
};

const setSelectedIdsReducer = (state, { selectedIds }) => {
    return { ...state, selectedIds };
};

const sendNotificationSuccessPostReducer = (state, { data }) => {
    return { ...state };
};

const showStudentLinkReducer = (state, { val }) => {
    return { ...state, showStudentLink: val };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_MEMBER_USERS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_MEMBER_USERS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_MEMBER_USERS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SET_SELECTED_IDS]: setSelectedIdsReducer,
    [ActionTypes.SEND_NOTIFICATION_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEND_NOTIFICATION_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEND_NOTIFICATION_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.ACTIVATE_ACCOUNT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.ACTIVATE_ACCOUNT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.ACTIVATE_ACCOUNT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SHOW_STUDENT_LINK]: showStudentLinkReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
